module.exports =
`
# プライバシーポリシー

MUZIK ONLINE(ムジークオンライン)（以下、「当社」といいます。）は、本ウェブサイト上で提供するサービス（以下、「本サービス」といいます。）におけるプライバシー情報の取扱いについて、以下のとおりプライバシーポリシー（以下、「本ポリシー」といいます。）を定めます。

- 個人情報の収集について

  1. 当社は，ユーザーがMUZIK Air(ムジークエア）に利用登録をする際、アカウントID、氏名、性別、生年月日、住所、電話番号、メールアドレス、職業、好きな音楽のタイプについての情報を収集します。

  2. ユーザーに適切かつ速やかに本サービスを提供するため、アカウントIDや連絡先の情報を収集します。たとえば、アカウント詳細情報の変更申請をする時、ユーザーのフィードバックを反映させる時、オンライン上でのプロモーション活動に参加する時などです。

- 個人情報の使用について

  1. 当社が収集した個人情報(ユーザー名やアカウントIDなど)は、本人確認の目的で使用されます。
  また、利用登録時に入力したメールアドレスは、ユーザーにお知らせや連絡をしたり、支払、または支払控除、請求書に関する情報を通知したり、当社の他のサービスについての更新をお知らせしたりするために使用されます。法律または規制上の要件を遵守する上で必要な場合、利用者の明示的な承諾がある場合、本ウェブサイトにおけるコンテンツに関する法的権利を保護するために必要があり、ユーザーの同意を得ることが困難な場合及びその他法令で認められる場合を除いて、いかなる場合も前記の目的以外の目的でユーザーの個人情報を使用することはありません。また、国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務や調査をすることに対して協力する必要がある場合を除いて、事前の同意なしに第三者へ個人情報を開示したりすることはありません。

  2. 当社は、メールニュースやマーケティングに関する通知を行うことがあります。ユーザーのメールアドレスはその連絡手段として使われることがありますが、もしそれらの通知を希望しない場合は、自身のアカウントにログインし、いつでも通知サービスを停止することができます。設定についてご不明な点がございましたら、カスタマーサービスにお問合せ下さい。

  3. 当社は、個人情報の取扱について、個人情報関連法令を遵守し、各種ガイドラインを参照しつつ、より適切な対応を講じるよう努めます。

- 個人情報の管理について

  1. 利用登録を行ったユーザーは自身の個人情報を検索、コピー、変更することができます。もし利用登録をしていない、または登録のための認証が完了していない場合は、それらの機能が利用できません。前記以外の状況で本サービスを利用できない場合、本サービスの利用を処理するために当社へ適切な個人情報や書類をお送りいただく必要があります。

  2. 当社は、国家の重要な利害に関係するおそれ、または国家機関に対して法的義務を妨害するおそれ、または、情報収集期間や第三者が不利益を被るおそれがある場合、ユーザーが自身の個人情報を変更、削除、修正することを拒否できる権利を持ちます。

- セキュリティ対策

  1. 当社は、個人情報の正確性及び安全性を確保するために、情報セキュリティ対策をはじめとする安全対策を実施し、個人情報への不正アクセス、または個人情報の紛失、破壊、改ざん、漏えい等の防止に努めます。

  2. 個人情報の漏えいを防ぐため、ご自身の個人情報、アカウントIDとパスワードなどはご自身で安全に管理して下さい。また、自身の個人情報への不正アクセスを防ぐため、本サービスを利用した後は、自身の端末かどうかにかかわらず、ご自身でログアウトし、ソフトウェアやブラウザを閉じて下さい。

  3. 個人情報の不正利用を防ぐため、ご自身のクレジットカード情報などを含む支払情報は、ご自身で安全に管理して下さい。

  4. 本ウェブサイトは、第三者のウェブサイトへのリンクを構成している場合があります。当社は、ユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。

  5. ユーザーは本サービスの利用、購入のために正確な情報を登録することに同意したものと見なします。もし、ご自身の個人情報を他人によって悪用された、もしくは異常を発見したら、速やかに当社へお知らせください。

  6. ユーザーは本サービスを利用する際、法律で認められている情報（第三者の権利を侵害しない、第三者との契約を破ることのない、または法律に違反しない情報）を提供することに同意したものとみなします。当社は、本サービスの提供により、ユーザーまたは第三者が被ったいかなる不利益または損害について、理由を問わず一切の責任を負わないものとします。

- その他の情報収集について

  本サービスは、ユーザーのIPアドレス、クッキー情報、関連するウェブの閲覧履歴などの情報を取得します。これらは本サービスの最適化、サービス向上のために使用され、その情報は暗号化され、必要なときに削除します。
プライバシーポリシーの変更

  当社は、法律または規定に基づいて、必要なときに本ポリシーを変更します。ポリシーを変更する際には、本ウェブサイトやメールで、ユーザーに通知いたします。

- お問合せ窓口

  本ポリシーに関するお問い合わせは、下記までお願いいたします。

  Email： service@muzik.com.tw

`
